// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/deliverability/snds/:app_group_id/snds_data" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { deliverabilitySndsAppGroupIdSndsData } from "./constants";
import type {
  DeliverabilitySndsAppGroupIdSndsDataParams,
  DeliverabilitySndsAppGroupIdSndsDataResult,
} from "./types";

export const getDataTableDeliverabilitySndsAppGroupIdSndsData = reactQueryTableFetcherAdapter(
  deliverabilitySndsAppGroupIdSndsData,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: DeliverabilitySndsAppGroupIdSndsDataParams
  ): Promise<DeliverabilitySndsAppGroupIdSndsDataResult> => {
    return fetch(
      `/deliverability/snds/${appGroupId}/snds_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        start_date: query?.start_date,
        end_date: query?.end_date,
        query: serializeQueryObjects(query),
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  }
);
